import React from 'react';
import { motion } from 'framer-motion';
import { Target, Compass, Heart } from 'lucide-react';
import { mockData } from '../mock';

const Vision = () => {
  const icons = [Compass, Target, Heart];

  return (
    <div className="min-h-screen bg-background text-foreground pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main Statement */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32 text-center"
        >
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-12 leading-tight tracking-tight">
            {mockData.vision.title}
          </h1>
        </motion.div>

        {/* Vision Statements */}
        <div className="space-y-20">
          {mockData.vision.statements.map((statement, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className={`flex flex-col lg:flex-row items-start gap-12 ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className="lg:w-1/3">
                  <div className="w-24 h-24 border-4 border-[#D4AF37] flex items-center justify-center mb-6 bg-background">
                    <Icon size={48} className="text-[#D4AF37]" />
                  </div>
                  <h2 className="text-4xl font-bold text-[#D4AF37] tracking-tight">{statement.heading}</h2>
                </div>
                <div className="lg:w-2/3">
                  <p className="text-2xl text-muted-foreground leading-relaxed">{statement.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-32 text-center"
        >
          <div className="bg-gradient-to-b from-[#D4AF37]/10 to-transparent border border-[#D4AF37]/30 p-16">
            <h2 className="text-4xl font-bold mb-6 tracking-tight">Join Our Vision</h2>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Be part of building the future. Explore opportunities with AR Holdings Group.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Vision;